import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Stocktaking } from 'entities/stocktaking'
import { ReactNode, useMemo } from 'react'
import { Badge, ProgressBar } from 'react-bootstrap'
import { Form } from 'utils/hooks'

export const stocktakingColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'stocktaking_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: 'ステータス', th: true, width: 100, align: 'center' },
            { name: '年月', th: true, width: 120, form: form },
            { name: '帳簿数', th: true, width: 100, align: 'center' },
            { name: '実棚数', th: true, width: 100, align: 'center' },
            { name: '進捗', th: true, minWidth: 200 },
        ],
    }
}

export type StocktakingTableDataProps = {
    stocktaking?: Stocktaking
    displaySetting: DisplaySetting
}

export const StocktakingTableData = ({ stocktaking, displaySetting }: StocktakingTableDataProps): JSX.Element => {
    if (!stocktaking) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const ratio = Math.round(((stocktaking.completedCount || 0) / (stocktaking.bookCount || 1)) * 100)
        return (
            <>
                <TableCell>{stocktaking.id}</TableCell>
                <TableCell align="center">{stocktaking.isCompleted ? <Badge bg="success">締め処理済</Badge> : <Badge bg="secondary">処理中</Badge>}</TableCell>
                <TableCell>{`${stocktaking.year}/${stocktaking.month}`}</TableCell>
                <TableCell align="center">{stocktaking.bookCount}</TableCell>
                <TableCell align="center">{stocktaking.physicalCount}</TableCell>
                <TableCell>
                    <ProgressBar now={ratio} label={ratio + '%'} />
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
